<div class="cw-dialog">
    <div class="cw-dialog-content">
        <div class="cw-flex-row">
            <phscw-global-help-menu class="help-menu"></phscw-global-help-menu>
            <phscw-global-help-details class="help-details" [popupData]="data"></phscw-global-help-details>
        </div>
    </div>
</div>
